import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import './ClassOverViewPie.css';

const data = [
  { name: 'Published', value: 3 },
  { name: 'Draft', value: 2 },
];

const COLORS = ['#0088FE', '#FFBB28']; // Blue for Published, Yellow for Draft

function ClassOverViewPie() {
  return (
    <div className='class-pie-component'>
      <span className='class-pie-title'>Class Overview</span>
      <div className='class-pie-line' />

      <PieChart width={300} height={250}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
          label
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </div>
  );
}

export default ClassOverViewPie;
